import {Component, OnInit, Renderer2, ViewChild, ElementRef, ɵConsole } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { global } from '../../shared/global';
// import { ChatService } from '../chat.service';
import { Injectable } from '@angular/core';
import * as io from 'socket.io-client';
import { CookieService } from 'ngx-cookie-service';
import { CreateshopService } from '../createshop/createshop.service';
import { Location } from '@angular/common';

@Injectable()

@Component({
  selector: 'app-chatcomponent',
  templateUrl: './chatcomponent.component.html',
  styleUrls: ['./chatcomponent.component.css']
})
export class ChatcomponentComponent implements OnInit {
  @ViewChild('divSent', { static: true }) divSent: ElementRef;
  @ViewChild('txtMessage', { static: true }) textInput: ElementRef;

  termConditionLink: any;

  loginCookie: any;
  shopCookie: any;
  socket: any;
  txtMessage: any;
  userNameDisplay: any;

  fromUser: string;
  toUser: string;
  
  constructor(private cookieService: CookieService, private renderer: Renderer2, private rout: ActivatedRoute, private service: CreateshopService, private location: Location) { 
    if(this.rout.snapshot.paramMap.has('storeId')) {
      this.toUser = this.rout.snapshot.paramMap.get('storeId');
      // this.userNameDisplay = this.toUser;
    }

    this.loginCookie = this.cookieService.get("login");
    this.shopCookie = this.cookieService.get("shop");

    if (this.loginCookie) {
      var compData = {
        "companyid": this.toUser
      }
      var storeData: any;
      
      this.service.getShopInfo(compData)
      .subscribe(shopData => {
        storeData = shopData;

        if (storeData.isSuccess == false) {
          console.log(storeData.message);
        }
        else {
          if (storeData.data.name) {
            this.userNameDisplay = storeData.data.name;
          } else {
            this.userNameDisplay = this.toUser;
          }
        }
      });
    }
  }

  ngOnInit() {
    this.termConditionLink = global.termConditionLink;

    if (this.loginCookie) {
      this.loginCookie = JSON.parse(this.cookieService.get("login"))

      this.fromUser = this.loginCookie.mobile;

      this.socket = io('http://socket.ask4token.com:1705?username=' + this.loginCookie.mobile + '&type=user');
    } else {
      if (this.shopCookie) {
        this.shopCookie = JSON.parse(this.cookieService.get("shop"));
        console.log("parin");
        console.log(this.shopCookie);
  
        this.fromUser = this.shopCookie.companyid;
  
        this.socket = io('http://socket.ask4token.com:1705?username=' + this.shopCookie.companyid + '&type=user');
      }
    }

    console.log(this.socket);
    this.connect();
  }

  someMethod(event:any){
    if(event.keyCode == 13){
       this.sendMessage();
    }else{
    }
 }

  isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return true;
    }
    return false;
  }

  connect() {
    this.socket.on('connect', function () {
      console.log("Socket Connected!");
    });

    this.socket.on('message', (data) => {      
      console.log(data);
      console.log('parin');
      if (!this.isJson(data)) {
        data = JSON.parse(data);
      }

      var receivedFrom = data.from;
      var receivedTo = data.to;

      console.log("From User" + this.fromUser);
      console.log("To User" + this.toUser);
      console.log("Received From" + receivedFrom);
      console.log("Received To" + receivedTo);

      if ((this.fromUser == receivedFrom && this.toUser == receivedTo) || this.fromUser == receivedTo && this.toUser == receivedFrom) {
        if (receivedFrom == this.fromUser) {
          // Sent
          const divMain: HTMLParagraphElement = this.renderer.createElement('div');
          divMain.setAttribute("class", "received");
          this.renderer.appendChild(this.divSent.nativeElement, divMain);

          const divSub: HTMLParagraphElement = this.renderer.createElement('div');
          divSub.setAttribute("class", "received-bubble");
          this.renderer.appendChild(divMain, divSub);

          const p: HTMLParagraphElement = this.renderer.createElement('p');
          p.innerHTML = data.msg;
          p.setAttribute("class", "mb-0 text-white");
          this.renderer.appendChild(divSub, p);

          const span: HTMLParagraphElement = this.renderer.createElement('span');
          span.setAttribute("class", "meta text-white");
          this.renderer.appendChild(divSub, span);

          // const time: HTMLParagraphElement = this.renderer.createElement('time');
          // time.innerHTML = "03:00 PM";
          // time.setAttribute("datetime", "2018");
          // this.renderer.appendChild(span, time);
        } else {
          // Received
          const divMain: HTMLParagraphElement = this.renderer.createElement('div');
          divMain.setAttribute("class", "sent-bubble");
          this.renderer.appendChild(this.divSent.nativeElement, divMain);

          const p: HTMLParagraphElement = this.renderer.createElement('p');
          p.innerHTML = data.msg;
          p.setAttribute("class", "mb-0");
          this.renderer.appendChild(divMain, p);

          const span: HTMLParagraphElement = this.renderer.createElement('span');
          span.setAttribute("class", "meta");
          this.renderer.appendChild(divMain, span);

          // const time: HTMLParagraphElement = this.renderer.createElement('time');
          // time.innerHTML = "03:00 PM";
          // time.setAttribute("datetime", "2018");
          // this.renderer.appendChild(span, time);
        }
      }
    });
  }

  sendMessage() {
    if (this.textInput.nativeElement.value) {
      this.socket.emit('message', {
        from: this.fromUser,
        to: this.toUser,
        msg: this.textInput.nativeElement.value
      });
      
      this.textInput.nativeElement.value = '';
    }
  }
}